import "../index.css";
import { IonIcon } from "@ionic/react";
import { bookOutline } from "ionicons/icons";

function Experience({ isActive }) {
  return (
    <article className={isActive ? "resume active" : "resume"} data-page="resume">

      <header>
        <h2 className="h2 article-title">Experience</h2>
      </header>

      <section className="timeline">
        <div className="title-wrapper">
          <div className="icon-box">
            <IonIcon icon={bookOutline}></IonIcon>
          </div>
          <h3 className="h3">Work Background</h3>
        </div>

        <ol className="timeline-list">

          {/* MOBILEUM */}
          <li className="timeline-item">
            <h4 className="h3 timeline-item-title">
              Senior Software Engineer @{" "}
              <a href="https://www.mobileum.com/" target="_blank" rel="noreferrer">
                Mobileum
              </a>
            </h4>

            <span>Nov 2025 — Present</span>

            <p className="timeline-text">
              • Designed and built a custom Redis backup and restore system with domain-specific logic <br />
              • Optimized throughput using Redis pipelining and Go concurrency, reducing network round trips <br />
              • Engineered high-performance data handling for large-scale in-memory datasets <br />
              • Applied clean architecture principles using interfaces and modular design
            </p>
          </li>

          {/* TYKE */}
          <li className="timeline-item">
            <h4 className="h3 timeline-item-title">
              Backend Developer @{" "}
              <a href="https://tykeinvest.com/" target="_blank" rel="noreferrer">
                Tyke
              </a>
            </h4>

            <span>Mar 2022 — Nov 2025</span>

            <p className="timeline-text">
              • Designed and led P2P investor flow as a Go microservice using gRPC and REST APIs <br />
              • Built end-to-end payment pipelines (Juspay, Tazapay, Cashfree) with transactional safety <br />
              • Implemented authentication systems using JWT, Redis, and AWS Cognito <br />
              • Reduced onboarding time by 50% via optimized KYC integrations <br />
              • Architected async workflows using RabbitMQ, AWS Lambda, and cron jobs (30% automation boost) <br />
              • Migrated Node.js services to Go, reducing memory usage and latency by ~50%
            </p>
          </li>

          {/* NEUROSENSUM */}
          <li className="timeline-item">
            <h4 className="h3 timeline-item-title">
              Software Developer @{" "}
              <a href="https://www.surveysensum.com/" target="_blank" rel="noreferrer">
                NeuroSensum
              </a>
            </h4>

            <span>Jun 2021 — Feb 2022</span>

            <p className="timeline-text">
              • Built Outlook Add-In using Microsoft APIs, increasing engagement for 40% of clients <br />
              • Managed Stripe payments module, reducing failures by 10%
            </p>
          </li>

          {/* INTERN */}
          <li className="timeline-item">
            <h4 className="h3 timeline-item-title">
              Software Engineer Intern @{" "}
              <a href="https://www.surveysensum.com/" target="_blank" rel="noreferrer">
                NeuroSensum
              </a>
            </h4>

            <span>Dec 2020 — Jun 2021</span>

            <p className="timeline-text">
              • Optimized data processing pipelines for large datasets, improving throughput <br />
              • Contributed to text analytics module, reducing response time for high-volume workloads
            </p>
          </li>

        </ol>
      </section>

      {/* EDUCATION */}
      <section className="timeline">
        <div className="title-wrapper">
          <div className="icon-box">
            <IonIcon icon={bookOutline}></IonIcon>
          </div>
          <h3 className="h3">Education</h3>
        </div>

        <ol className="timeline-list">
          <li className="timeline-item">
            <h4 className="h4 timeline-item-title">Chitkara University</h4>
            <span>2017 — 2021</span>
            <p className="timeline-text">
              Bachelor of Engineering (CSE)
            </p>
          </li>
        </ol>
      </section>

    </article>
  );
}

export default Experience;